export const IconEducationDegree: {
  name: 'icon_education_degree-6bfd230dcbb4'
} = {
  name: 'icon_education_degree-6bfd230dcbb4'
}
